import GrClose from '@meronex/icons/gr/GrClose';
import GrContract from '@meronex/icons/gr/GrContract';
import GrExpand from '@meronex/icons/gr/GrExpand';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useMediaQuery, useTheme } from '@material-ui/core';

import { winnreAuth } from '../../../utils/axios';
import SideModal from '../../Organisms/SideModal';
import CartSidebar from '../../Organisms/CartSidebar';
import { toIndianRs } from '../../../helpers';
import KYCModal from '../../Organisms/KYCModal';
import useBookingSummary from '../../../Hooks/use-bookingSummary';
import store from '../../../store';
import { dealAction } from '../../../store/deal-slice';
import { useEffect, useState } from 'react';

function CartModal({
    openCartModal,
    setOpenCartModal,
    cartValue,
    cartCount,
    setCartCount,
    setCartValue,
    screenBelowLg
}) {
    const history = useHistory();
    const dispatch = useDispatch();
    const theme = useTheme();
    const [showRewardsPopup, setShowRewardsPopup] = useState(false);
    const totalRewardsLength = useSelector((state) => state.auth.totalRewards);
            console.log('USER REWARDS LENGTH inside cartModal', totalRewardsLength);
    const { userAccountSummary, getUserAccountSummary } = useBookingSummary();
    // const screenBelowLg = useMediaQuery(theme.breakpoints.down('lg'));
    const [enableExpand, setEnableExpand] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(-2);
    const isKycModalEnabled = useSelector(
        (state) => state.deals.isKycModalEnabled
    );

    const isCartModalVisible = useSelector(
        (state) => state.deals.isCartModalVisible
    );
    // Kyc Check
    const checkKYCStatus = () => {
        winnreAuth({
            method: 'GET',
            url: `/winnre/user/user/kyc-status`
        }).then((message) => {
            if (message.message == 'COMPLETED') {
                if (!totalRewardsLength) {
                    setOpenCartModal(false);
                    dispatch(dealAction.setCartModalVisible(false));
                    setTimeout(() => {
                        dispatch(dealAction.setShowRewardsModal(true));
                    }, 300);
                    
                    return;
                }
                history.push(`/checkout`);
                setOpenCartModal(false);
                dispatch(dealAction.setCartModalVisible(false));
            }
            if (
                message.message == 'NOT_INITIATED' ||
                message.message == 'INITIATED' ||
                message.message === 'null' ||
                message.message === 'FAILED' ||
                message.message == 'PROCESSING'
            ) {
                dispatch(dealAction.setKycModalEnabled(true));
            }
        });
    };

    const onClickHandleDeleteCart = (index) => {
        setDeleteIndex(index);
    };
    // Delete Cart value
    const onDeleteCart = (item, itemId) => {
        window?.webengage?.track('RemoveFromCartClicked', {
            ProductName: `${item?.title}`,
            Price: `${item?.productMrp}`,
            PointsRequired: `${item?.points}`
        });
        const oldCartData = localStorage.getItem('cartData');

        if (!oldCartData) return;

        let cartData = JSON.parse(oldCartData);

        // Find the item to remove based on `itemId`
        const itemIndex = cartData.cartValues.findIndex(
            (item) => item.id === itemId
        );

        if (itemIndex === -1) return; // Item not found, do nothing

        // Get the item to remove for updating totalMrp
        const itemToRemove = cartData.cartValues[itemIndex];

        // Remove the item from cartValues
        cartData.cartValues.splice(itemIndex, 1);

        // Update totalMrp and totalProduct
        cartData.totalMrp -= itemToRemove.productMrp;
        cartData.totalPoints -= itemToRemove.points;
        cartData.totalShippingFee -= itemToRemove.productShippingFee;
        cartData.totalConvenienceFee -= itemToRemove.productConvenienceFee;
        cartData.totalProduct -= 1;
        setCartCount(cartData.totalProduct);
        setCartValue(cartData.cartValues);
        setDeleteIndex(-2);
        if (cartData.totalProduct === 0) onCloseModal();
        // Save updated cart data to localStorage
        localStorage.setItem('cartData', JSON.stringify(cartData));
        // Dispatch a custom event to notify other components
        window.dispatchEvent(new Event('cartUpdated'));
        const state = store.getState(); // Access the current store state
        const isRefresh = !state.deals.isRefreshRewards;
        dispatch(dealAction.setIsRewardRefreshing(isRefresh));
    };

    const handleCheckOut = () => {
        getUserAccountSummary();
        checkKYCStatus();
    };

    useEffect(() => {
        if (!isCartModalVisible) {
            console.log('working Modal');
            setOpenCartModal(false);
        }
    }, [isCartModalVisible]);

    const onCloseModal = () => {
        window?.webengage?.track('AddMoreProducts');
        dispatch(dealAction.setCartModalVisible(false));
        setOpenCartModal(false);
    };

    const onClickSelectedItem = (id) => {
        onCloseModal();
        history.push(`/rewardStore/${id}`);
    };

    // Return the modal for both small and expand screen
    const getCartDetails = () => {
        return (
            <SideModal
                visible={openCartModal}
                onClick={onCloseModal}
                className={`w-full  ${
                    isKycModalEnabled ? 'top-[80%]' : ''
                } lg:top-0 lg:w-[35%] lg:max-w-[400px] xl:w-[25%] z-[99999] !h-[50vh] lg:!h-[100vh] !bottom-[4.12rem] !lg:bottom-0`}
            >
                <div className="h-full flex flex-col pl-3.5 pt-6 pr-3.5">
                    <div className="flex justify-between  ">
                        <h1 className="font-bold text-base  ">Gift Basket</h1>

                        <GrClose
                            onClick={onCloseModal}
                            className={` h-4 w-4 cursor-pointer mr-2 mt-2`}
                        />
                    </div>
                    <div className=" lg:flex-1 !overflow-y-visible scrollbar-thin scrollbar-track-blue-50 scrollbar-thumb-blue-700">
                        <div
                            className={`flex flex-col 
                          pt-6 h-full  space-y-4`}
                        >
                            {cartValue.map((cart, index) => (
                                <div className="relative items-start pb-2    border-b border-gray-200">
                                    <div
                                        key={index}
                                        className="flex flex-row gap-3 "
                                    >
                                        {/* Product Image */}
                                        <div className="flex flex-col   min-w-max items-start">
                                            <img
                                                src={
                                                    cart?.thumbnailImageUrl
                                                        ? cart?.thumbnailImageUrl
                                                        : cart?.displayImageUrl
                                                }
                                                onClick={() => {
                                                    onClickSelectedItem(
                                                        cart?.id
                                                    );
                                                }}
                                                alt="Product Image"
                                                className="w-24 h-24 lg:w-20 lg:h-20 object-cover cursor-pointer"
                                            />
                                        </div>
                                        <div className="flex flex-col  gap-1   justify-center flex-grow ">
                                            <p className="font-semibold text-sm text-black">
                                                {cart?.title}
                                            </p>
                                            <p className="text-sm text-blue-700 line-through">
                                                MRP{' '}
                                                {toIndianRs(cart?.productMrp)}
                                            </p>
                                        </div>
                                        <div className="sm:w-[10%] flex justify-center mr-1.5">
                                            <button
                                                onClick={() =>
                                                    onClickHandleDeleteCart(
                                                        index
                                                    )
                                                }
                                                className="text-red-500  p-1 rounded-full transition"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="32"
                                                    height="32"
                                                    viewBox="0 0 26 26"
                                                >
                                                    <g
                                                        id="Group_12543"
                                                        data-name="Group 12543"
                                                        transform="translate(-1310 -69)"
                                                    >
                                                        {/* <rect
                                                        id="Rectangle_17370"
                                                        data-name="Rectangle 17370"
                                                        width="26"
                                                        height="26"
                                                        rx="5"
                                                        transform="translate(1310 69)"
                                                        fill=""
                                                    /> */}
                                                        <g
                                                            id="delete-93"
                                                            transform="translate(1315.333 76)"
                                                        >
                                                            <path
                                                                id="Path_6546"
                                                                data-name="Path 6546"
                                                                d="M146.465,149.1H141.6a1.893,1.893,0,0,1-1.89-1.892v-7.564h8.643v7.564A1.894,1.894,0,0,1,146.465,149.1Zm-6.213-8.914v7.022a1.352,1.352,0,0,0,1.35,1.351h4.863a1.351,1.351,0,0,0,1.35-1.351V140.19Z"
                                                                transform="translate(-136.443 -138.027)"
                                                                fill="red"
                                                                stroke="red"
                                                                stroke-width="0.5"
                                                            />
                                                            <path
                                                                id="Path_6547"
                                                                data-name="Path 6547"
                                                                d="M352.964,2.163h-3.78V1.082A1.082,1.082,0,0,1,350.263,0h1.621a1.081,1.081,0,0,1,1.079,1.082Zm-3.24-.542h2.7V1.082a.54.54,0,0,0-.54-.54h-1.62a.541.541,0,0,0-.54.54Z"
                                                                transform="translate(-343.484)"
                                                                fill="red"
                                                                stroke="red"
                                                                stroke-width="0.5"
                                                            />
                                                            <path
                                                                id="Path_6548"
                                                                data-name="Path 6548"
                                                                d="M13.262,140.19H1.918a.272.272,0,0,1,0-.542H13.262a.271.271,0,0,1,0,.542ZM7.59,146.672a.272.272,0,0,1-.271-.27v-4.593a.271.271,0,0,1,.542,0V146.4A.272.272,0,0,1,7.59,146.672Zm-2.161-.54a.272.272,0,0,1-.271-.27V142.35a.271.271,0,0,1,.542,0v3.511a.27.27,0,0,1-.27.27Zm4.051,0a.27.27,0,0,1-.268-.27V142.35a.27.27,0,0,1,.539,0v3.511a.271.271,0,0,1-.271.27Z"
                                                                transform="translate(0 -138.027)"
                                                                fill="red"
                                                                stroke="red"
                                                                stroke-width="0.5"
                                                            />
                                                        </g>
                                                    </g>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>

                                    {index === deleteIndex && (
                                        <div className="flex flex-col justify-center absolute inset-0 bg-white bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
                                            <div className="flex justify-center items-center mb-4"></div>

                                            <p className="text-center text-sm font-semibold text-black-600 mb-4">
                                                Remove item from Gift Basket?
                                            </p>

                                            <div className="flex items-center justify-center gap-6 mb-4">
                                                <button
                                                    className="bg-white border border-primary text-sm text-primary px-4 py-2 rounded-lg"
                                                    onClick={() =>
                                                        setDeleteIndex(-2)
                                                    }
                                                >
                                                    No
                                                </button>
                                                <button
                                                    className="bg-primary text-white text-sm px-4 py-2 rounded-lg "
                                                    onClick={() =>
                                                        onDeleteCart(
                                                            cart,
                                                            cart?.id
                                                        )
                                                    }
                                                >
                                                    Yes
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="flex  items-center gap-2 z-[99] lg:z-0  bg-white left-0 right-0 bottom-0 w-full fixed lg:static py-3 px-3.5 lg:px-0">
                        <button
                            onClick={onCloseModal}
                            className={`flex  w-[50%]   p-[10px]  px-[5px]     items-center gap-2 border justify-center border-primary font-normal text-primary rounded-md transition   text-sm`}
                        >
                            <span>Add more products</span>
                        </button>
                        <>
                            {/*   Checkout   */}
                            <button
                                onClick={() => handleCheckOut()}
                                className={` flex rounded-md w-[50%] p-[10px]  px-[5px]     text-center bg-primary flex items-center justify-center   text-white font-normal  text-sm `}
                            >
                                <span> Checkout</span>
                            </button>
                        </>
                    </div>
                </div>
            </SideModal>
        );
    };
    return (
        <div>
            {!screenBelowLg && (
                <div>
                    {enableExpand === false ? (
                        <CartSidebar
                            visible={true || openCartModal}
                            onClick={onCloseModal}
                            className={` top-[48%] lg:top-0 `}
                        >
                            <div className="h-full flex flex-col pt-6">
                                <div className="absolute top-8 -left-2  w-4 h-4 bg-white border-l border-b border-gray-300 transform rotate-45"></div>

                                <div className="flex items-center justify-between px-3">
                                    <h1 className="font-bold text-lg">Bag</h1>

                                    <GrExpand
                                        onClick={() => {
                                            setEnableExpand(true);
                                        }}
                                        className={` h-4 w-4 cursor-pointer`}
                                    />
                                </div>

                                <div className="flex flex-col  overflow-y-scroll pt-6  scrollbar-hide h-full space-y-4 px-3">
                                    {cartValue.map((cart, index) => (
                                        <div
                                            key={index}
                                            onClick={() => {
                                                setEnableExpand(true);
                                            }}
                                            className="flex flex-col items-start gap-2 cursor-pointer "
                                        >
                                            {/* Product Image */}
                                            <div className="flex flex-row justify-between items-center w-full">
                                                <img
                                                    src={
                                                        cart?.thumbnailImageUrl
                                                            ? cart?.thumbnailImageUrl
                                                            : cart?.displayImageUrl
                                                    }
                                                    alt="Product Image"
                                                    className="w-full h-full object-contain border border-gray-200"
                                                />
                                            </div>
                                            <div className="flex flex-col space-y-1 pt-1 flex-grow">
                                                <p className="text-xs font-bold text-blue-700 line-through">
                                                    MRP{' '}
                                                    {toIndianRs(
                                                        cart?.productMrp
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className=" w-full">
                                    {/* <button
                                onClick={handleCheckOut}
                                disabled={cartCount}
                                className="bg-primary text-white py-2 px-4 rounded-md  transition"
                            >
                                Checkout
                            </button> */}
                                    <button
                                        onClick={handleCheckOut}
                                        disabled={cartCount <= 0}
                                        className={`py-[10px] px-6 transition text-sm w-full font-semibold ${
                                            cartCount <= 0
                                                ? 'bg-gray-400 cursor-not-allowed'
                                                : 'bg-primary text-white'
                                        }`}
                                    >
                                        Checkout
                                    </button>
                                </div>
                            </div>
                        </CartSidebar>
                    ) : (
                        getCartDetails()
                    )}
                </div>
            )}
            {screenBelowLg && <div>{getCartDetails()}</div>}
        </div>
    );
}
export default CartModal;
